export const getLabel = (field) => {
  switch (field) {
    case "date":
      return "Date";
    case "tag_number":
      return "Link Number";
    case "rule_id":
      return "Rule ID";
    case "advertiser_id":
      return "Advertiser";
    case "publisher_id":
      return "Publisher";
    case "channel":
      return "Channel";
    case "geo":
      return "Geo";
    case "total_searches":
      return "Total Searches";
    case "monetized_searches":
      return "Monetized Searches";
    case "clicks":
      return "Clicks";
    case "ctr":
      return "CTR";
    case "monetized_ctr":
      return "Monetized CTR";
    case "gross_revenue":
      return "Gross Revenue";
    case "net_revenue":
      return "Net Revenue";
    case "rpm":
      return "RPM";
    case "rpmm":
      return "Monetized RPM";
    case "rpc":
      return "RPC";
    case "tag_description":
      return "Link Description";
    case "followon_searches":
      return "Followon Searches";
    case "initial_searches":
      return "Initial Searches";
    default:
      return field;
  }
};
